document.addEventListener('shopify:section:load', (e) => {
  if (e.target.querySelector('[data-product-root]')) {
    initProduct(e.target);
  }
  if (e.target.querySelector('[data-recommendations]')) {
    initRecommendations(e.target);
  }
});

document.addEventListener('shopify:section:unload', (e) => {
  if (e.target._productCtx) {
    e.target._productCtx.revert();
  }
  const root = e.target.querySelector
    ? e.target.querySelector('[data-product-root]')
    : null;
  runTeardown(root || e.target);
});

/* The PDP binds listeners and observers on window, so every one of them has to
   come back off when the theme editor swaps the section out. */
function registerTeardown(root, fn) {
  if (!root) return;
  if (!root._virsaayPdpTeardown) root._virsaayPdpTeardown = [];
  root._virsaayPdpTeardown.push(fn);
}

function runTeardown(root) {
  if (!root || !root._virsaayPdpTeardown) return;
  root._virsaayPdpTeardown.forEach((fn) => {
    try {
      fn();
    } catch (err) {}
  });
  root._virsaayPdpTeardown = null;
}

function initProduct(section) {
  const root = (section.matches && section.matches('[data-product-root]'))
    ? section
    : section.querySelector('[data-product-root]');
  if (!root) return;

  let ctx = window.gsap ? gsap.context(() => {}, root) : null;
  root._productCtx = ctx;

  const state = {
    sectionId: root.dataset.sectionId,
    productId: root.dataset.productId,
    url: root.dataset.url,
    variants: [],
    currentVariant: null,
  };

  try {
    const jsonEl = root.querySelector('[data-product-json]');
    if (jsonEl) {
      state.variants = JSON.parse(jsonEl.textContent);
    }
  } catch (err) {}

  // 1. Variant Selection
  const picker = root.querySelector('[data-variant-picker]');
  if (picker) {
    picker.addEventListener('change', (e) => {
      if (!e.target.matches('[data-option-input]')) return;
      
      const inputs = Array.from(picker.querySelectorAll('[data-option-input]:checked'));
      const options = inputs.map(input => input.value);
      
      const variant = state.variants.find(v => {
        return options.every((opt, i) => v[`option${i+1}`] === opt);
      });

      if (variant) {
        state.currentVariant = variant;
        updateVariantUI(root, variant, state);
      }
    });
  }

  // 2. Add to Cart
  const form = root.querySelector('[data-product-form]');
  if (form) {
    form.addEventListener('submit', async (e) => {
      e.preventDefault();
      
      const submitBtn = form.querySelector('[data-atc]');
      const errorEl = form.querySelector('[data-atc-error]');
      
      if (submitBtn) {
        submitBtn.classList.add('is-loading');
        submitBtn.disabled = true;
      }
      if (errorEl) {
        errorEl.hidden = true;
      }

      const formData = new FormData(form);
      const items = [{
        id: formData.get('id'),
        quantity: parseInt(formData.get('quantity') || 1, 10)
      }];

      try {
        const res = await fetch(window.VirsaayTheme.routes.cartAdd + '.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ items, sections: 'cart-drawer,cart-icon-bubble' })
        });
        
        const data = await res.json();
        
        if (data.status) {
          throw new Error(data.description || window.VirsaayTheme.strings.cartError);
        }

        document.dispatchEvent(new CustomEvent('virsaay:cart:updated', { detail: { cart: data, sections: data.sections } }));
        document.dispatchEvent(new CustomEvent('virsaay:cart:open'));
      } catch (err) {
        if (errorEl) {
          errorEl.textContent = err.message;
          errorEl.hidden = false;
        }
      } finally {
        if (submitBtn) {
          submitBtn.classList.remove('is-loading');
          submitBtn.disabled = false;
        }
      }
    });

    // Enable the hidden ID input (it ships disabled)
    const hiddenIdInput = form.querySelector('input[name="id"][data-variant-id]');
    if (hiddenIdInput) {
      hiddenIdInput.disabled = false;
    }

    // Buy now: add the chosen size and quantity, then straight to checkout.
    const buyNow = form.querySelector('[data-buy-now]');
    if (buyNow) {
      buyNow.addEventListener('click', async () => {
        const errorEl = form.querySelector('[data-atc-error]');
        const formData = new FormData(form);
        const id = formData.get('id');
        if (!id) return;
        buyNow.classList.add('is-loading');
        buyNow.disabled = true;
        if (errorEl) errorEl.hidden = true;
        try {
          const res = await fetch(window.VirsaayTheme.routes.cartAdd + '.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ items: [{ id, quantity: parseInt(formData.get('quantity') || 1, 10) }] })
          });
          const data = await res.json();
          if (data.status) throw new Error(data.description || window.VirsaayTheme.strings.cartError);
          window.location.href = (window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/') + 'checkout';
        } catch (err) {
          if (errorEl) {
            errorEl.textContent = err.message;
            errorEl.hidden = false;
          }
          buyNow.classList.remove('is-loading');
          buyNow.disabled = false;
        }
      });
    }
  }

  // Quantity stepper
  const qtyRoot = root.querySelector('[data-quantity-root]');
  if (qtyRoot) {
    qtyRoot.addEventListener('click', e => {
      const stepBtn = e.target.closest('[data-qty-step]');
      if (!stepBtn) return;
      const input = qtyRoot.querySelector('[data-qty-input]');
      if (!input) return;
      
      const step = parseInt(stepBtn.dataset.qtyStep, 10);
      let val = parseInt(input.value, 10) || parseInt(input.min, 10) || 1;
      val += step;
      if (input.min && val < parseInt(input.min, 10)) val = parseInt(input.min, 10);
      if (input.max && val > parseInt(input.max, 10)) val = parseInt(input.max, 10);
      input.value = val;
    });
  }

  // 3. Gallery
  initGallery(root);

  // 5. Accordions
  initAccordions(root, ctx);

  // 5. Size Guide Modal
  initModals(root);

  // 6. Panel chrome — measured header offset and the panel's scroll fade
  initPanel(root);

  // 6b. Full details view
  initDetails(root);

  // 7. Sticky Info
  initStickyInfo(root);
}

function updateVariantUI(root, variant, state) {
  // Update URL
  if (history.replaceState) {
    const url = new URL(window.location);
    url.searchParams.set('variant', variant.id);
    history.replaceState({}, '', url);
  }

  // Hidden ID input
  const hiddenIdInput = root.querySelector('input[name="id"][data-variant-id]');
  if (hiddenIdInput) hiddenIdInput.value = variant.id;

  // ATC Button
  const atcBtn = root.querySelector('[data-atc]');
  const atcLabel = root.querySelector('[data-atc-label]');
  if (atcBtn && atcLabel) {
    if (variant.available) {
      atcBtn.disabled = false;
      atcLabel.textContent = window.VirsaayTheme.strings.addToCart;
    } else {
      atcBtn.disabled = true;
      atcLabel.textContent = window.VirsaayTheme.strings.soldOut;
    }
  }
  const buyNowBtn = root.querySelector('[data-buy-now]');
  if (buyNowBtn) buyNowBtn.disabled = !variant.available;

  // Bring the variant's own media to the front of the strip
  if (variant.featured_media && root._virsaayGalleryGoTo) {
    const index = root._virsaayGalleryIndexOf(variant.featured_media.id);
    if (index > -1) root._virsaayGalleryGoTo(index);
  }

  // Fetch Section Rendering API for Price, SKU, etc if needed.
  // We'll update the price via Section Rendering API.
  const url = `${state.url}?variant=${variant.id}&section_id=${state.sectionId}`;
  fetch(url)
    .then(r => r.text())
    .then(html => {
      const parser = new DOMParser();
      const doc = parser.parseFromString(html, 'text/html');
      
      const slots = ['data-price-slot', 'data-sku-slot', 'data-quantity-slot', 'data-buy-slot'];
      slots.forEach(attr => {
        const curr = root.querySelector(`[${attr}]`);
        const next = doc.querySelector(`[${attr}]`);
        if (curr && next) curr.innerHTML = next.innerHTML;
      });
    });
}

/* The gallery is one continuous filmstrip.

   Desktop shows three slides across and drives the track with a transform so
   the active slide lands in the middle third. The offset is clamped to the
   strip's own ends, which is what keeps the canvas full bleed — the first and
   last slides sit flush rather than centring themselves and leaving a gutter.

   Mobile hands the same track to native scroll-snap so it swipes, and the
   chrome follows the scroll position rather than the other way round. */
function initGallery(root) {
  const gallery = root.querySelector('[data-gallery]');
  if (!gallery) return;

  const viewport = gallery.querySelector('[data-gallery-viewport]');
  const track = gallery.querySelector('[data-gallery-track]');
  const thumbs = Array.from(gallery.querySelectorAll('[data-thumb]'));
  const thumbsViewport = gallery.querySelector('[data-gallery-thumbs-viewport]');
  const counter = gallery.querySelector('[data-gallery-counter]');
  const prevBtn = gallery.querySelector('[data-gallery-prev]');
  const nextBtn = gallery.querySelector('[data-gallery-next]');
  const items = track ? Array.from(track.querySelectorAll('[data-media-item]')) : [];

  const startIndex = Math.min(
    Math.max(parseInt(gallery.dataset.startIndex, 10) || 0, 0),
    Math.max(items.length - 1, 0)
  );
  let activeIndex = startIndex;

  if (viewport && track && items.length) {
    const wide = window.matchMedia('(min-width: 990px)');
    const pad = (n) => String(n).padStart(2, '0');

    const reduced = () =>
      (window.VirsaayMotion && window.VirsaayMotion.reduced) ||
      window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    /* The strip never ends. A copy of the media sits either side of the real
       run, so the filmstrip always has something to show past both edges;
       once a move settles outside the middle copy the index is shifted back
       by one run with transitions off, which is invisible because the slide
       under the viewport is identical either way.

       Only the middle copy carries the real ids and tab wiring — the clones
       are inert and hidden from assistive tech, which still reads the rail
       and the counter as the source of position. */
    const realCount = items.length;
    const looping = realCount > 1;
    let slides = items;
    let virtualIndex = startIndex;

    if (looping) {
      const makeClone = (el) => {
        const clone = el.cloneNode(true);
        clone.removeAttribute('id');
        clone.removeAttribute('role');
        clone.removeAttribute('aria-labelledby');
        clone.setAttribute('aria-hidden', 'true');
        clone.setAttribute('data-clone', '');
        clone.classList.remove('is-active');
        // A clone can be on screen from the first paint, so nothing defers
        clone.querySelectorAll('img').forEach((img) => {
          img.setAttribute('loading', 'eager');
          img.removeAttribute('fetchpriority');
        });
        return clone;
      };

      const lead = items.map(makeClone);
      const tail = items.map(makeClone);
      // Prepending in reverse keeps the run in order ahead of the originals
      for (let i = lead.length - 1; i >= 0; i--) {
        track.insertBefore(lead[i], track.firstChild);
      }
      tail.forEach((clone) => track.appendChild(clone));

      slides = Array.from(track.querySelectorAll('[data-media-item]'));
      virtualIndex = realCount + startIndex;
    }

    const toReal = (v) => ((v % realCount) + realCount) % realCount;

    /* Where the active slide sits: the middle third normally, the left third
       while the full details view covers the other two. */
    const leadIn = (vw, slideW) =>
      root.classList.contains('is-expanded') ? 0 : (vw - slideW) / 2;

    // The copy of `real` that is the shortest move from where we are now
    const nearestVirtual = (real) => {
      if (!looping) return real;
      let delta = real - toReal(virtualIndex);
      if (delta > realCount / 2) delta -= realCount;
      if (delta < -realCount / 2) delta += realCount;
      return virtualIndex + delta;
    };

    /* Position the strip so the active slide is centred, clamped to the ends.
       Measured from the live layout rather than offsetLeft so a fractional
       slide width cannot accumulate drift across the strip. */
    const applyOffset = (animate) => {
      if (!wide.matches) {
        track.style.transform = '';
        track.style.transition = '';
        return;
      }

      const vw = viewport.clientWidth;
      const slideW = slides[0].getBoundingClientRect().width;
      if (!vw || !slideW) return;

      const gap = parseFloat(getComputedStyle(track).columnGap) || 0;
      const step = slideW + gap;

      let offset = leadIn(vw, slideW) - virtualIndex * step;
      if (!looping) {
        // Without a loop the strip is clamped so it stays full bleed
        const trackW = slides.length * step - gap;
        offset = Math.min(0, Math.max(Math.min(0, vw - trackW), offset));
      }

      if (!animate || reduced()) {
        track.style.transition = 'none';
        track.style.transform = `translate3d(${offset}px, 0, 0)`;
        // Commit the jump before transitions are allowed back on
        void track.offsetWidth;
        track.style.transition = '';
      } else {
        track.style.transform = `translate3d(${offset}px, 0, 0)`;
      }
    };

    /* Bring the index back into the middle copy once a move has settled. The
       slide on screen is the same either side of the shift, so re-seating the
       track without a transition cannot be seen. */
    let rewrapTimer = null;
    const scheduleRewrap = () => {
      if (!looping) return;
      window.clearTimeout(rewrapTimer);
      rewrapTimer = window.setTimeout(() => {
        if (virtualIndex >= realCount && virtualIndex < realCount * 2) return;
        virtualIndex = realCount + toReal(virtualIndex);
        if (wide.matches) {
          applyOffset(false);
        } else {
          scrollToVirtual('auto');
        }
        markActive();
      }, 700);
    };

    /* Only the slide under the middle of the viewport lights up. The same
       media appears once per copy, so this keys off the position in the strip
       rather than the media id. */
    const markActive = () => {
      slides.forEach((slide, i) => {
        const active = i === virtualIndex;
        slide.classList.toggle('is-active', active);
        if (slide.hasAttribute('data-clone')) return;
        if (active) slide.removeAttribute('aria-hidden');
        else slide.setAttribute('aria-hidden', 'true');
      });
    };

    const scrollToVirtual = (behavior) => {
      const slide = slides[virtualIndex];
      if (slide) {
        slide.scrollIntoView({ behavior, block: 'nearest', inline: 'center' });
      }
    };

    /* Thumbs are real tabs: aria-selected marks the active one and the
       stylesheet keys off .is-active. Roving tabindex keeps the rail
       keyboard navigable. */
    const syncChrome = () => {
      const index = toReal(virtualIndex);
      activeIndex = index;
      const id = items[index].dataset.mediaId;

      markActive();

      thumbs.forEach((t) => {
        const active = t.dataset.mediaId === id;
        t.classList.toggle('is-active', active);
        t.setAttribute('aria-selected', active ? 'true' : 'false');
        t.tabIndex = active ? 0 : -1;
      });

      if (counter) counter.textContent = pad(index + 1);
      // A looping strip has no ends to run out of
      if (prevBtn) prevBtn.disabled = !looping && index === 0;
      if (nextBtn) nextBtn.disabled = !looping && index === items.length - 1;
    };

    // Keep the active thumbnail in view when the rail is taller than its box
    const revealThumb = (index) => {
      if (!thumbsViewport || !thumbs[index]) return;
      const box = thumbsViewport.getBoundingClientRect();
      const rect = thumbs[index].getBoundingClientRect();
      if (wide.matches) {
        if (rect.top < box.top || rect.bottom > box.bottom) {
          thumbsViewport.scrollTop += rect.top - box.top;
        }
      } else if (rect.left < box.left || rect.right > box.right) {
        thumbsViewport.scrollLeft += rect.left - box.left;
      }
    };

    // Move to a position in the strip; `virtual` may sit outside the middle
    // copy, and is folded back once the move has settled.
    const goToVirtual = (virtual) => {
      if (virtual === virtualIndex) return;
      if (!looping && (virtual < 0 || virtual >= slides.length)) return;
      virtualIndex = virtual;

      if (wide.matches) {
        applyOffset(true);
      } else {
        scrollToVirtual(reduced() ? 'auto' : 'smooth');
      }

      syncChrome();
      revealThumb(activeIndex);
      scheduleRewrap();
    };

    // Public move, addressed by real media index
    const goTo = (index) => {
      if (index < 0 || index >= realCount) return;
      goToVirtual(nearestVirtual(index));
    };

    const stepBy = (delta) => {
      if (looping) {
        // If we are at the edge of the cloned copies, silently snap back to center set
        if (delta > 0 && virtualIndex >= realCount * 2) {
          virtualIndex -= realCount;
          if (wide.matches) applyOffset(false);
          else scrollToVirtual('auto');
        } else if (delta < 0 && virtualIndex < realCount) {
          virtualIndex += realCount;
          if (wide.matches) applyOffset(false);
          else scrollToVirtual('auto');
        }
      }
      goToVirtual(virtualIndex + delta);
    };

    // Clicking a flanking (non-active) slide centers it
    slides.forEach((slide, i) => {
      slide.addEventListener('click', (e) => {
        if (!wide.matches) return;
        if (i !== virtualIndex) {
          e.preventDefault();
          goToVirtual(i);
        }
      });
    });

    // Immediate rewrap upon CSS transition completion
    track.addEventListener('transitionend', (e) => {
      if (e.target !== track || !looping || !wide.matches) return;
      if (virtualIndex < realCount || virtualIndex >= realCount * 2) {
        virtualIndex = realCount + toReal(virtualIndex);
        applyOffset(false);
        markActive();
      }
    });

    // Pointer drag for desktop infinite canvas interaction
    let isDragging = false;
    let startX = 0;
    let deltaX = 0;
    let dragFrame = null;
    let dragVw = 0;
    let dragSlideW = 0;
    let dragGap = 0;

    track.addEventListener('pointerdown', (e) => {
      if (!wide.matches || e.button !== 0) return;
      if (e.target.closest('button, a, input, select, textarea')) return;
      isDragging = true;
      startX = e.clientX;
      deltaX = 0;
      dragVw = viewport.clientWidth;
      dragSlideW = slides[0] ? slides[0].getBoundingClientRect().width : 0;
      dragGap = parseFloat(getComputedStyle(track).columnGap) || 0;
      track.style.transition = 'none';
      try { track.setPointerCapture(e.pointerId); } catch (_) {}
    });

    track.addEventListener('pointermove', (e) => {
      if (!isDragging || !wide.matches) return;
      deltaX = e.clientX - startX;
      if (dragFrame) return;
      dragFrame = window.requestAnimationFrame(() => {
        dragFrame = null;
        if (!isDragging) return;
        const step = dragSlideW + dragGap;
        const offset = leadIn(dragVw, dragSlideW) - virtualIndex * step + deltaX;
        track.style.transform = `translate3d(${offset}px, 0, 0)`;
      });
    });

    const endDrag = () => {
      if (!isDragging) return;
      isDragging = false;
      if (dragFrame) {
        window.cancelAnimationFrame(dragFrame);
        dragFrame = null;
      }
      track.style.transition = '';
      if (Math.abs(deltaX) > 40) {
        stepBy(deltaX < 0 ? 1 : -1);
      } else {
        applyOffset(true);
      }
    };

    track.addEventListener('pointerup', endDrag);
    track.addEventListener('pointercancel', endDrag);

    thumbs.forEach((thumb) => {
      thumb.addEventListener('click', () => {
        const index = items.findIndex(
          (item) => item.dataset.mediaId === thumb.dataset.mediaId
        );
        if (index > -1) goTo(index);
      });
    });

    if (prevBtn) prevBtn.addEventListener('click', () => stepBy(-1));
    if (nextBtn) nextBtn.addEventListener('click', () => stepBy(1));

    // Arrow keys walk the rail once a thumbnail has focus
    thumbs.forEach((thumb) => {
      thumb.addEventListener('keydown', (e) => {
        const forward = e.key === 'ArrowDown' || e.key === 'ArrowRight';
        const back = e.key === 'ArrowUp' || e.key === 'ArrowLeft';
        if (!forward && !back) return;
        e.preventDefault();
        let next = activeIndex + (forward ? 1 : -1);
        if (looping) next = toReal(next);
        else if (next < 0 || next >= realCount) return;
        goTo(next);
        if (thumbs[next]) thumbs[next].focus();
      });
    });

    /* Mobile drives the strip by swiping, so the position is read back off
       the scroll rather than written to it. */
    let frame = null;
    const onScroll = () => {
      if (wide.matches || frame) return;
      frame = window.requestAnimationFrame(() => {
        frame = null;
        const box = viewport.getBoundingClientRect();
        const centre = box.left + box.width / 2;
        let best = 0;
        let bestDistance = Infinity;
        slides.forEach((slide, i) => {
          const rect = slide.getBoundingClientRect();
          const distance = Math.abs(rect.left + rect.width / 2 - centre);
          if (distance < bestDistance) {
            bestDistance = distance;
            best = i;
          }
        });
        if (best !== virtualIndex) {
          virtualIndex = best;
          syncChrome();
          revealThumb(activeIndex);
        }
        // Re-seat only once the swipe has come to rest
        scheduleRewrap();
      });
    };

    /* Crossing the breakpoint swaps which mechanism is in play, so re-assert
       the active slide in whichever presentation is now in force. */
    const onBreakpoint = () => {
      if (wide.matches) {
        viewport.scrollLeft = 0;
        applyOffset(false);
      } else {
        track.style.transform = '';
        scrollToVirtual('auto');
      }
      revealThumb(activeIndex);
    };

    let resizeFrame = null;
    const onResize = () => {
      if (resizeFrame) return;
      resizeFrame = window.requestAnimationFrame(() => {
        resizeFrame = null;
        applyOffset(false);
      });
    };

    viewport.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onResize);
    if (wide.addEventListener) {
      wide.addEventListener('change', onBreakpoint);
    } else if (wide.addListener) {
      wide.addListener(onBreakpoint);
    }

    registerTeardown(root, () => {
      viewport.removeEventListener('scroll', onScroll);
      window.removeEventListener('resize', onResize);
      if (wide.removeEventListener) {
        wide.removeEventListener('change', onBreakpoint);
      } else if (wide.removeListener) {
        wide.removeListener(onBreakpoint);
      }
      if (frame) window.cancelAnimationFrame(frame);
      if (resizeFrame) window.cancelAnimationFrame(resizeFrame);
      window.clearTimeout(rewrapTimer);
    });

    root._virsaayGalleryGoTo = goTo;
    root._virsaayGalleryRealign = () => applyOffset(true);
    root._virsaayGalleryIndexOf = (mediaId) =>
      items.findIndex((item) => item.dataset.mediaId === String(mediaId));

    syncChrome();
    onBreakpoint();
    // Images landing late change the measured slide width
    if (document.fonts && document.fonts.ready) {
      document.fonts.ready.then(() => applyOffset(false)).catch(() => {});
    }
    window.addEventListener('load', () => applyOffset(false), { once: true });
  }

  initLightbox(root, gallery, () => activeIndex, items);
}

/* Lightbox — a dedicated viewing mode over a neutral ground, opening on
   whichever media the strip is currently showing. It swipes on touch and
   steps with the arrows or the keyboard. */
function initLightbox(root, gallery, getActiveIndex, items) {
  const zoomBtn = gallery.querySelector('[data-zoom-open]');
  const lightbox = root.querySelector('[data-lightbox]');
  if (!zoomBtn || !lightbox) return;

  const closeBtn = lightbox.querySelector('[data-lightbox-close]');
  const lbTrack = lightbox.querySelector('[data-lightbox-track]');
  const lbPrev = lightbox.querySelector('[data-lightbox-prev]');
  const lbNext = lightbox.querySelector('[data-lightbox-next]');
  const lbCounter = lightbox.querySelector('[data-lightbox-counter]');
  const lbItems = lbTrack
    ? Array.from(lbTrack.querySelectorAll('[data-lightbox-item]'))
    : [];
  if (!lbItems.length) return;

  let lbIndex = 0;

  const syncLightbox = () => {
    if (lbCounter) lbCounter.textContent = String(lbIndex + 1);
    if (lbPrev) lbPrev.disabled = lbIndex === 0;
    if (lbNext) lbNext.disabled = lbIndex === lbItems.length - 1;
  };

  const showLb = (index, behavior) => {
    if (index < 0 || index >= lbItems.length) return;
    lbIndex = index;
    lbItems[index].scrollIntoView({
      behavior: behavior || 'smooth',
      block: 'nearest',
      inline: 'center',
    });
    syncLightbox();
  };

  const close = () => {
    lightbox.hidden = true;
    document.documentElement.classList.remove('virsaay-no-scroll');
    if (window.VirsaayMotion && window.VirsaayMotion.releaseFocus) {
      window.VirsaayMotion.releaseFocus();
    }
    zoomBtn.focus();
  };

  zoomBtn.addEventListener('click', () => {
    lightbox.hidden = false;
    document.documentElement.classList.add('virsaay-no-scroll');
    if (window.VirsaayMotion && window.VirsaayMotion.trapFocus) {
      window.VirsaayMotion.trapFocus(lightbox);
    }

    // Open on the media the strip is showing, when that media is zoomable
    const current = items[getActiveIndex()];
    const id = current && current.dataset.mediaId;
    const match = id ? lbItems.findIndex((el) => el.dataset.mediaId === id) : -1;
    showLb(match > -1 ? match : 0, 'auto');
  });

  if (closeBtn) closeBtn.addEventListener('click', close);
  if (lbPrev) lbPrev.addEventListener('click', () => showLb(lbIndex - 1));
  if (lbNext) lbNext.addEventListener('click', () => showLb(lbIndex + 1));

  // Swiping the track is the primary gesture on touch; keep the chrome in step
  let lbFrame = null;
  lbTrack.addEventListener(
    'scroll',
    () => {
      if (lbFrame) return;
      lbFrame = window.requestAnimationFrame(() => {
        lbFrame = null;
        const box = lbTrack.getBoundingClientRect();
        const centre = box.left + box.width / 2;
        let best = 0;
        let bestDistance = Infinity;
        lbItems.forEach((item, i) => {
          const rect = item.getBoundingClientRect();
          const distance = Math.abs(rect.left + rect.width / 2 - centre);
          if (distance < bestDistance) {
            bestDistance = distance;
            best = i;
          }
        });
        lbIndex = best;
        syncLightbox();
      });
    },
    { passive: true }
  );

  const onKeydown = (e) => {
    if (lightbox.hidden) return;
    if (e.key === 'Escape') close();
    else if (e.key === 'ArrowLeft') showLb(lbIndex - 1);
    else if (e.key === 'ArrowRight') showLb(lbIndex + 1);
  };

  document.addEventListener('keydown', onKeydown);

  registerTeardown(root, () => {
    document.removeEventListener('keydown', onKeydown);
    if (lbFrame) window.cancelAnimationFrame(lbFrame);
  });
}

/* Panel chrome. The header is sticky and its height is the only thing between
   the canvas and the top of the window, so it is measured rather than guessed
   — a stale constant would leave the composition a few pixels tall and put a
   scrollbar on a page meant to sit still. */
function initPanel(root) {
  const header = document.querySelector('[data-header]');
  if (header) {
    let headerFrame = null;
    const measure = () => {
      const h = Math.round(header.getBoundingClientRect().height);
      if (h > 0) root.style.setProperty('--vpdp-header', h + 'px');
    };
    const onResize = () => {
      if (headerFrame) return;
      headerFrame = window.requestAnimationFrame(() => {
        headerFrame = null;
        measure();
      });
    };
    measure();
    window.addEventListener('resize', onResize);
    let headerRo = null;
    if (window.ResizeObserver) {
      headerRo = new ResizeObserver(measure);
      headerRo.observe(header);
    }
    registerTeardown(root, () => {
      window.removeEventListener('resize', onResize);
      if (headerFrame) window.cancelAnimationFrame(headerFrame);
      if (headerRo) headerRo.disconnect();
    });
  }

  /* Fade the panel's last line while there is more of it to scroll */
  const col = root.querySelector('.vpdp__info-col');
  const info = root.querySelector('[data-info-column]');
  if (!col || !info) return;

  const sync = () => {
    const overflowing =
      info.scrollHeight - info.clientHeight - info.scrollTop > 2;
    col.classList.toggle('has-scroll-shadow', overflowing);
  };

  info.addEventListener('scroll', sync, { passive: true });
  window.addEventListener('resize', sync);
  let ro = null;
  if (window.ResizeObserver) {
    ro = new ResizeObserver(sync);
    ro.observe(info);
  }
  sync();

  registerTeardown(root, () => {
    info.removeEventListener('scroll', sync);
    window.removeEventListener('resize', sync);
    if (ro) ro.disconnect();
  });
}

/* Full details view.

   One state class, `.is-expanded` on the section root, drives both layouts
   (see virsaay-product.css): on desktop the panel grows across the canvas and
   the details become its second column; on mobile they open in place. */
function initDetails(root) {
  const panel = root.querySelector('[data-pdp-details]');
  if (!panel) return;

  const info = root.querySelector('[data-info-column]');
  const title = panel.querySelector('.vpdp-details__title');
  const wide = window.matchMedia('(min-width: 990px)');
  const reduced = () =>
    (window.VirsaayMotion && window.VirsaayMotion.reduced) ||
    window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  structureDescription(panel);
  pruneDetailAccordions(panel);

  let lastTrigger = null;
  let focusTimer = null;
  const isOpen = () => root.classList.contains('is-expanded');

  const openers = () => Array.from(root.querySelectorAll('[data-pdp-details-open]'));

  const sync = (open) => {
    root.classList.toggle('is-expanded', open);
    panel.setAttribute('aria-hidden', open ? 'false' : 'true');
    if ('inert' in panel) panel.inert = !open;

    openers().forEach((btn) => {
      btn.setAttribute('aria-expanded', open ? 'true' : 'false');
      const label = btn.querySelector('[data-details-trigger-label]');
      if (label) label.textContent = open ? btn.dataset.labelClose : btn.dataset.labelOpen;
    });

    if (root._virsaayGalleryRealign) root._virsaayGalleryRealign();
  };

  const open = (trigger) => {
    if (isOpen()) return;
    lastTrigger = trigger || null;
    sync(true);
    if (info) info.scrollTop = 0;

    window.clearTimeout(focusTimer);
    if (wide.matches) {
      // Let the panel finish growing before focus lands in the new column
      focusTimer = window.setTimeout(() => {
        if (isOpen() && title) title.focus({ preventScroll: true });
      }, reduced() ? 0 : 420);
    } else {
      // Bring the opening details into view beneath the sticky header
      const header = document.querySelector('[data-header]');
      const offset = header ? header.getBoundingClientRect().height : 0;
      const top = panel.getBoundingClientRect().top + window.scrollY - offset - 12;
      window.scrollTo({ top, behavior: reduced() ? 'auto' : 'smooth' });
    }
  };

  const close = () => {
    if (!isOpen()) return;
    window.clearTimeout(focusTimer);
    const hadFocus = panel.contains(document.activeElement);
    sync(false);
    if (info) info.scrollTop = 0;
    if (hadFocus || wide.matches) {
      const back = lastTrigger && lastTrigger.isConnected ? lastTrigger : openers()[0];
      if (back) back.focus({ preventScroll: true });
    }
  };

  const onClick = (e) => {
    const trigger = e.target.closest('[data-pdp-details-open]');
    if (trigger && root.contains(trigger)) {
      e.preventDefault();
      if (isOpen()) close();
      else open(trigger);
      return;
    }
    if (e.target.closest('[data-pdp-details-close]') && panel.contains(e.target)) {
      e.preventDefault();
      close();
    }
  };

  const onKeydown = (e) => {
    if (e.key !== 'Escape' || !isOpen()) return;
    // Dialogs opened from inside the panel close first
    if (document.querySelector('.vpdp-modal:not([hidden]), .vpdp-lightbox:not([hidden])')) return;
    close();
  };

  const onBreakpoint = () => {
    if (root._virsaayGalleryRealign) root._virsaayGalleryRealign();
  };

  sync(false);
  root.addEventListener('click', onClick);
  document.addEventListener('keydown', onKeydown);
  if (wide.addEventListener) wide.addEventListener('change', onBreakpoint);
  else if (wide.addListener) wide.addListener(onBreakpoint);

  registerTeardown(root, () => {
    root.removeEventListener('click', onClick);
    document.removeEventListener('keydown', onKeydown);
    if (wide.removeEventListener) wide.removeEventListener('change', onBreakpoint);
    else if (wide.removeListener) wide.removeListener(onBreakpoint);
    window.clearTimeout(focusTimer);
  });
}

/* Lifts labelled lines out of the product description into spec rows.

   Merchants write descriptions many ways, so this reads the rendered HTML
   rather than guessing at a format:
     "Fabric: Pure lawn"                  → Fabric | Pure lawn
     "<strong>Care:</strong><ul>…</ul>"   → Care   | the list
     "<h4>Details</h4><p>…</p>"           → Details| the paragraph
     "Shirt:<br>Embroidered front 1.25m"  → Shirt  | Embroidered front 1.25m
   Anything before the first label stays as the lead paragraph; long prose
   after a finished row is kept, in order, below the rows. When no labels are
   found the description is left exactly as written. */
const SPEC_LABEL = /^\s*([A-Za-zÀ-ɏ][A-Za-zÀ-ɏ0-9 &/'’()+-]{0,38}?)\s*[:：]\s*([\s\S]*)$/;

function isLabelText(text) {
  const clean = text.trim();
  if (!clean || clean.length > 40) return false;
  if (clean.split(/\s+/).length > 5) return false;
  return !/[.!?,;]/.test(clean);
}

function formatLabel(text) {
  const clean = text.replace(/\s+/g, ' ').replace(/[:：]\s*$/, '').trim();
  // SHOUTED labels read as sentence case; mixed case is kept as written
  if (clean === clean.toUpperCase()) {
    return clean.charAt(0) + clean.slice(1).toLowerCase();
  }
  return clean;
}

function escapeHtml(text) {
  const span = document.createElement('span');
  span.textContent = text;
  return span.innerHTML;
}

function descriptionLines(container) {
  const lines = [];
  const BLOCK = /^(P|DIV|H[1-6]|LI|BLOCKQUOTE|SECTION|ARTICLE|HEADER|FOOTER|FIGURE)$/;
  const LIST = /^(UL|OL|TABLE|DL)$/;
  const SKIP = /^(SCRIPT|STYLE|META|LINK|TEMPLATE)$/;

  const walk = (el, headingTag) => {
    let buffer = [];

    const flush = () => {
      if (!buffer.length) return;
      const holder = document.createElement('div');
      buffer.forEach((node) => holder.appendChild(node.cloneNode(true)));
      buffer = [];
      const text = holder.textContent.replace(/\s+/g, ' ').trim();
      if (!text) return;
      // A line that is nothing but bold text reads as a heading
      const only = holder.children.length === 1 && holder.textContent.trim() === holder.children[0].textContent.trim();
      const bold = only && /^(STRONG|B)$/.test(holder.children[0].tagName);
      lines.push({ html: holder.innerHTML.trim(), text, heading: !!headingTag || bold });
    };

    Array.from(el.childNodes).forEach((node) => {
      if (node.nodeType === Node.TEXT_NODE) {
        buffer.push(node);
      } else if (node.nodeType === Node.ELEMENT_NODE) {
        if (SKIP.test(node.tagName)) return;
        if (node.tagName === 'BR') {
          flush();
        } else if (LIST.test(node.tagName)) {
          flush();
          if (node.textContent.trim()) lines.push({ html: node.outerHTML, text: node.textContent.trim(), list: true });
        } else if (BLOCK.test(node.tagName)) {
          flush();
          walk(node, /^H[1-6]$/.test(node.tagName));
        } else {
          buffer.push(node);
        }
      }
    });
    flush();
  };

  walk(container, false);
  return lines;
}

function structureDescription(panel) {
  const lede = panel.querySelector('[data-pdp-details-lede]');
  const specs = panel.querySelector('[data-pdp-details-specs]');
  if (!lede || !specs || lede.dataset.structured === 'true') return;
  lede.dataset.structured = 'true';

  const lines = descriptionLines(lede);
  const intro = [];
  const after = [];
  const rows = [];
  let current = null;

  const startRow = (label, openEnded) => {
    const name = formatLabel(label);
    const existing = rows.find((row) => row.key === name.toLowerCase());
    current = existing || { key: name.toLowerCase(), label: name, parts: [] };
    current.openEnded = openEnded;
    if (!existing) rows.push(current);
  };

  lines.forEach((line) => {
    if (line.list) {
      if (current) current.parts.push(line.html);
      else intro.push(line.html);
      return;
    }

    const match = line.text.match(SPEC_LABEL);
    if (match && isLabelText(match[1]) && !/^\/\//.test(match[2])) {
      const rest = match[2].trim();
      startRow(match[1], !rest);
      if (rest) current.parts.push(`<p>${escapeHtml(rest)}</p>`);
      return;
    }

    if (line.heading && isLabelText(line.text)) {
      startRow(line.text, true);
      return;
    }

    const paragraph = `<p>${line.html}</p>`;
    if (!current) {
      intro.push(paragraph);
    } else if (current.openEnded || (line.text.length <= 80 && !/[.!?]$/.test(line.text))) {
      // Continuation of the row above: a heading's body, or a short spec line
      current.parts.push(paragraph);
    } else {
      after.push(paragraph);
    }
  });

  const filled = rows.filter((row) => row.parts.length);
  if (!filled.length) return;

  // Rows already supplied by metafields win over the parsed copy
  const taken = new Set(
    Array.from(specs.querySelectorAll('[data-spec-key]')).map((el) => el.dataset.specKey.toLowerCase())
  );
  const pinned = specs.querySelector('[data-spec-pin="end"]');

  filled.forEach((row) => {
    if (taken.has(row.key)) return;
    const wrap = document.createElement('div');
    wrap.className = 'vpdp-details__spec';
    wrap.dataset.specKey = row.key;
    const dt = document.createElement('dt');
    dt.textContent = row.label;
    const dd = document.createElement('dd');
    dd.className = 'rte';
    dd.innerHTML = row.parts.join('');
    wrap.append(dt, dd);
    specs.insertBefore(wrap, pinned);
  });
  specs.hidden = false;

  lede.innerHTML = intro.join('');
  lede.hidden = !intro.length;

  if (after.length) {
    const notes = document.createElement('div');
    notes.className = 'vpdp-details__lede rte';
    notes.innerHTML = after.join('');
    lede.after(notes);
  }
}

/* The details accordions are rendered before the description is read, so
   drop any that came out empty (no spec rows, no prose). */
function pruneDetailAccordions(panel) {
  panel.querySelectorAll('[data-details-acc]').forEach((wrap) => {
    const inner = wrap.querySelector('[data-accordion-inner]');
    if (!inner) return;
    const visible = Array.from(inner.children).some((el) => !el.hidden && el.textContent.trim());
    wrap.hidden = !visible;
  });
}

function initAccordions(root, ctx) {
  const accordions = root.querySelectorAll('[data-accordion]');
  accordions.forEach(acc => {
    const trigger = acc.querySelector('[data-accordion-trigger]');
    const panel = acc.querySelector('[data-accordion-panel]');
    
    trigger.addEventListener('click', () => {
      const isExpanded = trigger.getAttribute('aria-expanded') === 'true';
      
      if (!isExpanded) {
        trigger.setAttribute('aria-expanded', 'true');
        panel.hidden = false;
        
        if (window.VirsaayMotion && !window.VirsaayMotion.reduced && window.gsap && ctx) {
          ctx.add(() => {
            gsap.fromTo(panel, 
              { height: 0, opacity: 0 }, 
              { height: 'auto', opacity: 1, duration: 0.4, ease: 'power3.out' }
            );
          });
        }
      } else {
        trigger.setAttribute('aria-expanded', 'false');
        
        if (window.VirsaayMotion && !window.VirsaayMotion.reduced && window.gsap && ctx) {
          ctx.add(() => {
            gsap.to(panel, {
              height: 0, opacity: 0, duration: 0.3, ease: 'power3.out',
              onComplete: () => { panel.hidden = true; panel.style.height = ''; panel.style.opacity = ''; }
            });
          });
        } else {
          panel.hidden = true;
        }
      }
    });
  });
}

function initModals(root) {
  const triggers = root.querySelectorAll('[data-modal-open]');
  triggers.forEach(trigger => {
    trigger.addEventListener('click', () => {
      const modalId = trigger.getAttribute('data-modal-open');
      const modal = document.getElementById(modalId);
      if (modal) {
        if (modal.parentNode !== document.body) document.body.appendChild(modal);
        modal.hidden = false;
        if (window.VirsaayMotion && window.VirsaayMotion.trapFocus) {
          window.VirsaayMotion.trapFocus(modal);
        }
      }
    });
  });

  const closes = root.querySelectorAll('[data-modal-close]');
  closes.forEach(close => {
    close.addEventListener('click', () => {
      const modal = close.closest('[data-modal]');
      if (modal) {
        modal.hidden = true;
        if (window.VirsaayMotion && window.VirsaayMotion.releaseFocus) {
          window.VirsaayMotion.releaseFocus();
        }
      }
    });
  });
}

/* Mobile purchase bar. It appears only once the real button has scrolled off
   the top of the screen, and never while it is still reachable.

   The state is read from the buy block's own geometry rather than from an
   IntersectionObserver crossing. An observer only reports when the
   intersection state changes, so a scroll long enough to jump the element
   clean over the viewport — a restored scroll position, an in-page anchor, a
   fast flick — passes straight from "below" to "above" without ever
   intersecting, and the bar would never arrive. */
function initStickyInfo(root) {
  const atcBar = root.querySelector('[data-sticky-atc]');
  if (!atcBar) return;
  const buySlot = root.querySelector('[data-buy-slot]');
  if (!buySlot) return;

  let hideTimer = null;
  let shown = false;
  let frame = null;

  const setShown = (next) => {
    if (next === shown) return;
    shown = next;
    window.clearTimeout(hideTimer);

    if (next) {
      atcBar.hidden = false;
      // Let the hidden -> shown paint land before the transform transitions
      requestAnimationFrame(() => {
        if (shown) atcBar.classList.add('is-active');
      });
    } else {
      atcBar.classList.remove('is-active');
      hideTimer = window.setTimeout(() => {
        if (!shown) atcBar.hidden = true;
      }, 300);
    }
  };

  const sync = () => {
    frame = null;
    // Entirely above the top edge — the primary button has left the viewport
    setShown(buySlot.getBoundingClientRect().bottom < 0);
  };

  const onScroll = () => {
    if (frame) return;
    frame = window.requestAnimationFrame(sync);
  };

  window.addEventListener('scroll', onScroll, { passive: true });
  window.addEventListener('resize', onScroll);
  sync();

  registerTeardown(root, () => {
    window.removeEventListener('scroll', onScroll);
    window.removeEventListener('resize', onScroll);
    if (frame) window.cancelAnimationFrame(frame);
    window.clearTimeout(hideTimer);
  });
}

function initRecommendations(section) {
  const root = (section.matches && section.matches('[data-recommendations]'))
    ? section
    : section.querySelector('[data-recommendations]');
  if (!root) return;

  const url = root.dataset.url;
  if (!url) return;

  fetch(url)
    .then(res => res.text())
    .then(html => {
      const parser = new DOMParser();
      const doc = parser.parseFromString(html, 'text/html');
      const newRecs = doc.querySelector('.vpdp-recs');
      if (newRecs) {
        root.replaceWith(newRecs);
      }
    })
    .catch(err => console.error(err));
}

// Global initialization for existing elements
function bootProduct() {
  document.querySelectorAll('[data-product-root]').forEach(initProduct);
  document.querySelectorAll('[data-recommendations]').forEach(initRecommendations);
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', bootProduct);
} else {
  bootProduct();
}
